import {cn} from '../../lib/utils';

import type {AnchorHTMLAttributes} from 'react';

export type ExternalLinkProps = AnchorHTMLAttributes<HTMLAnchorElement>;

/**
 * Anchor that opens in a new tab with the safe `rel`, styled with the link color.
 * Centralizes the `target`/`rel` pair so callers can't forget it; extend the look via className.
 */
export function ExternalLink({className, children, ...props}: ExternalLinkProps) {
  return (
    <a
      data-slot="external-link"
      target="_blank"
      rel="noopener noreferrer"
      className={cn('text-fg-link', className)}
      {...props}
    >
      {children}
    </a>
  );
}
